import { DEFAULT_ERR_MESSAGE } from '../constants';
const getErrorMessage = (error = {}) => {
  if (!error.networkError) return {
    errorMessage: error.message || DEFAULT_ERR_MESSAGE
  };
  const networkErrMessage = error.networkError.result ? error.networkError.result.message : error.networkError.error;
  return {
    errorMessage: networkErrMessage,
    errorCode: error.networkError.statusCode
  };
};
export default getErrorMessage;
//# sourceMappingURL=get-error-message.js.map